import React, { createContext, useContext, useEffect} from 'react'
import { CopyQueueManager } from '../../../services/copyQueueManager'
import { PhotoUploadManager } from '../../../services/photoUploadManager'
import { OAPhotoManager } from '../../../services/oaPhotoManager'
import { DBGPhotoManager } from '../../../services/dbgPhotoManager'


const copyQueueManager = new CopyQueueManager()
const photoUploadManager = new PhotoUploadManager()
const oaPhotoManager = new OAPhotoManager()
const dbgPhotoManager = new DBGPhotoManager()

export const PhotoManagerContextClass = createContext(null)

export function PhotoManagerContext({
  children,
  setProgress, 
  setMessage
}) {
  
  useEffect(()=>{
    console.log('PhotoManagerContext | useEffect [setProgress, setMessage]')
    copyQueueManager.setDisplayMessage(setMessage)
    copyQueueManager.setDisplayProgress(setProgress)
    // photoUploadManager.setDisplayMessage(setMessage)
    // photoUploadManager.setDisplayProgress(setProgress)
    oaPhotoManager.setDisplayMessage(setMessage)
    oaPhotoManager.setDisplayProgress(setProgress)
    // dropboxManager.setDisplayMessage(setMessage)
  }, [setProgress, setMessage])

  return (
    <PhotoManagerContextClass.Provider value={{
      copyQueueManager,
      photoUploadManager,
      oaPhotoManager,
      dbgPhotoManager
    }}>
        {children}
    </PhotoManagerContextClass.Provider>
  )
}

export function usePhotoManagerContext() {
  return useContext(PhotoManagerContextClass)
}


